import React, { useState } from "react";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");

  const handleDelete = (e) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter your email.");
      return;
    }

    alert(`Your Email is added. Your account will be deleted in the next 15 days`);
    setEmail("");
    // Trigger delete flow (API call or Firebase function)
    // console.log("Deleting account for:", email);
  };

  return (
    <section className="delete-account-section">
      <form onSubmit={handleDelete} className="delete-account-form">
        <h4 className="form-title">Delete Account</h4>

        <div className="form-group">
          <label htmlFor="emailInput" className="form-label">
            Email address
          </label>
          <input
            type="email"
            id="emailInput"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn-danger">
          Delete Account
        </button>
      </form>
    </section>
  );
};

export default DeleteAccount;
